import React from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

// TD1-10482 (M4, PRD D-29/D-32): the "Drop off / Pick Up" table rows of the React print pages
// (Rental Summary, Pick List), one row per stop of rental.displayTransports — label from the API
// ("Drop Off 1", "Pick Up 2"…), rendered like the schedule-derived rows they replace: "No Preference"
// when the schedule says so, a single date/time for a point-in-time stop, start "Through" end otherwise.
const renderDateTime = (value, timeZone) => (
  <div>
    <FormattedDate
      weekday='short'
      month='short'
      day='numeric'
      year='numeric'
      value={value}
    />{' '}
    <FormattedTime value={value} timeZone={timeZone} timeZoneName='short' />
  </div>
);

export const usesUniformStops = (rental) =>
  ['default_delivery', 'custom_delivery'].includes(
    rental?.delivery?.delivery_type ?? rental?.deliveryType
  ) &&
  Array.isArray(rental?.displayTransports) &&
  rental.displayTransports.length > 0;

const PrintStopRows = ({ displayTransports, timeZone }) =>
  displayTransports.map((stop, index) => (
    <tr
      className='top'
      key={`${stop.transportType}-${stop.startDateTime}-${index}`}
    >
      <td>{stop.label}</td>
      <td>
        {stop.noPreference ? (
          <div>No Preference</div>
        ) : (
          renderDateTime(stop.startDateTime, timeZone)
        )}
        {(stop.noPreference || stop.hasDeliveryWindow) && (
          <>
            <div className='caption'>Through</div>
            {stop.noPreference ? (
              <div>No Preference</div>
            ) : (
              renderDateTime(stop.endDateTime, timeZone)
            )}
          </>
        )}
      </td>
    </tr>
  ));

export default PrintStopRows;
